import { Button, DialogActions, DialogContent, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React from 'react';


type Props = {
  close: any;
  handleSaveFutureWeekData: any;
  handleSaveThisWeekData: any;
  isLoading: boolean;
  createPtoRequestError?: any;
};

const SaveChangesModal = (props: Props) => {
  const {
    close,
    handleSaveFutureWeekData,
    handleSaveThisWeekData,
    isLoading,
    createPtoRequestError,
  } = props;
  return (
    <Box p={3}>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', rowGap: 1 }}>
          <Typography
            mb={3}
            variant="h5"
          >
            Apply availability changes to
          </Typography>
          <Button
            autoFocus
            onClick={handleSaveThisWeekData}
            focusRipple
            variant="contained"
            fullWidth
            disabled={isLoading}
          >
            This week only
          </Button>
          <Button
            autoFocus
            focusRipple
            onClick={handleSaveFutureWeekData}
            disabled={isLoading}
            variant="outlined"
            fullWidth
          >
            This and all future weeks
          </Button>
          <Button
            fullWidth
            autoFocus
            focusRipple
            sx={{
              color: '#384250',
            }}
            variant="text"
            onClick={close}
          >
            Cancel
          </Button>
          {createPtoRequestError && (
            <Typography
              color={'error'}
              sx={{ fontSize: '14px' }}
            >
              {createPtoRequestError}
            </Typography>
          )}
        </Box>
      </DialogContent>
    </Box>
  );
};

export default SaveChangesModal;
